import { createSlice } from '@reduxjs/toolkit'
import { forEach, map } from 'lodash-es'
import { replace } from '@lagunovsky/redux-react-router'
import { xFestivalName } from './core/constants/baseUrls'
import {
  IFestivalEdition,
  IFestivalMenuItem,
  IUserProfile,
} from './core/services/menu'
interface AppState {
  festivalName?: string
  festivals: IFestivalMenuItem[]
  email: string
  user?: IUserProfile
  isSidebarCollapsed: boolean
  activeEdition?: IFestivalEdition
  activeFestival?: IFestivalMenuItem
}

const getFestival = () => {
  const paths = window.location.pathname.split('/')
  const festivals = JSON.parse(localStorage.getItem('festivals') || '[]')
  const platforms = map(festivals, (fest) => fest.platformName)
  let festivalName = undefined

  forEach(paths, (path) => {
    if (platforms.includes(path)) {
      festivalName = path
      xFestivalName.value = path
      localStorage.setItem('festivalName', path)
      return festivalName
    }
  })

  return festivalName
}

const initialState: AppState = {
  festivalName: getFestival() || localStorage.getItem('festivalName') || '',
  festivals: [],
  email: '',
  isSidebarCollapsed: false,
  activeEdition: undefined,
  activeFestival: undefined,
}

export const appSlice = createSlice({
  name: 'app',
  initialState,
  reducers: {
    setFestivalName: (state, action) => {
      state.festivalName = action.payload.festivalName
      xFestivalName.value = action.payload.festivalName
      localStorage.setItem('festivalName', action.payload.festivalName)
      return state
    },
    clear: (state) => {
      state.festivals = []
      state.festivalName = ''
      localStorage.removeItem('festivals')
      localStorage.removeItem('festivalName')
      state.email = ''
      state.user = undefined
      return state
    },
    saveFestivals: (state, action) => {
      localStorage.setItem(
        'festivals',
        JSON.stringify(action.payload.festivals),
      )
      state.festivals = action.payload.festivals
      return state
    },
    selectEdition: (state, action) => {
      const rawFestivals = localStorage.getItem('festivals')
      if (!rawFestivals || rawFestivals === '') {
        return
      }
      let festivals: IFestivalMenuItem[] = JSON.parse(rawFestivals || '')
      const editionId = action.payload.edition
      const festival = action.payload.festival
      let oldEditionId = ''
      festivals = festivals.map((f) => {
        if (f.id === festival.id) {
          if (f.editions) {
            const activeEdition = f.editions.filter((e) => e.active)
            if (activeEdition.length > 0) {
              oldEditionId = activeEdition[0].id
            }
            f.editions.forEach((e) => {
              e.active = e.id === editionId
            })
          }
        }
        return f
      })

      state.activeEdition = festivals
        .find((f) => f.id === festival.id)
        ?.editions.find((e) => e.id === editionId)
      state.activeFestival = festival
      const url = new URL(window.location.href)
      const newUrl = url.toString().replace(oldEditionId, editionId)
      localStorage.setItem('festivals', JSON.stringify(festivals))
      if (url.pathname !== new URL(newUrl).pathname) {
        replace(newUrl, {
          replace: true,
        })
      }

      return state
    },
    setEmail: (state, action) => {
      state.email = action.payload.email
      return state
    },
    setUser: (state, action) => {
      state.user = action.payload.user
      return state
    },
    toggleSidebar: (state) => {
      state.isSidebarCollapsed = !state.isSidebarCollapsed
      return state
    },
  },
})

// Action creators are generated for each case reducer function
export const {
  setFestivalName,
  saveFestivals,
  clear,
  selectEdition,
  setEmail,
  setUser,
  toggleSidebar,
} = appSlice.actions

export default appSlice.reducer
